// TODO: insert tag manager id
let tagManagerId = 'GTM-XXXXXX';
let cookieInformationElem;

function acceptCookies() {
  console.log('acceptCookies');
  setCookie('acceptcookies', '1');
  if (process.env.ENV === 'production') {
    // TODO: replace with live tag manager snippet
  } else if (process.env.ENV === 'staging') {
    // TODO: replace with staging tag manager snippet
  }
  window[`ga-disable-${tagManagerId}`] = false;
  hideCookieBanner();
}

function hideCookieBanner() {
  setCookie('hidecookieinfo', '1');
  cookieInformationElem.style.display = 'none';
}

function setCookie(name, value) {
  let d = new Date();
  d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = `${name}=${value};path=/;` + expires;
}

function disagreeCookies() {
  console.log('disagreeCookies');
  window[`ga-disable-${tagManagerId}`] = true;
  hideCookieBanner();
}

function resetCookies() {
  if (confirm('Cookie-Einstellungen zurücksetzen?')) {
    disagreeCookies();
    document.cookie = `acceptcookies=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
    setCookie('hidecookieinfo', '0');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const resetCookiesBtns = document.querySelectorAll('.reset-cookies-btn');
  if (resetCookiesBtns) {
    resetCookiesBtns.forEach(el => {
      el.addEventListener('click', resetCookies);
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  cookieInformationElem = document.querySelector('#cookies-information');

  if (!cookieInformationElem) {
    return;
  }

  cookieInformationElem.querySelector('#btn-accept-all').addEventListener('click', acceptCookies);

  if (document.cookie.indexOf('hidecookieinfo=1') === -1) {
    const path = window.location.pathname.split('/');
    if (path.includes('privacy') || path.includes('datenschutz')) {
      cookieInformationElem.style.display = 'none';
    } else {
      cookieInformationElem.style.display = 'flex';
    }
  } else {
    if (document.cookie.indexOf('acceptcookies=1') !== -1) {
      acceptCookies();
    } else {
      disagreeCookies();
    }
  }
});
